module.exports = {"id":"dp5_2l1q2","text":"Identifying Needs and Digital Technological Responses","instructions":"A digital assistant can help complete tasks by responding to user input.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.2","questionType":"PickOne","random":false,"options":[{"id":"dp5_2l1q2-a1","text":"True","score":1.8},{"id":"dp5_2l1q2-a2","text":"Not Sure","score":0},{"id":"dp5_2l1q2-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.2/l1q2.json
// module id = 1303
// module chunks = 41